/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Organization',dictionary:{"de":{"references":{"contacts":"Kontakte"},"general":{"shortName":"Kurzname","fullName":"Name","vatId":"UID-Nummer"},"__getters":{"localAddress":"Address","internationalAddress":"Address"},"address":{"street":"Straße und Nummer","zipCode":"PLZ","city":"Ort","country":"Land","__getters":{"localAddress":"Adresse","interationalAddress":"Adresse"}},"communication":{"phone":"Telefon","mobile":"Mobil","email":"Email"}},"en":{"references":{"contacts":"Contacts"},"general":{"shortName":"Short Name","fullName":"Name","vatId":"VAT-Number"},"__getters":{"localAddress":"Address","internationalAddress":"Address"},"address":{"street":"Street and Number","zipCode":"Zip-Code","city":"City","country":"Country","__getters":{"localAddress":"Address","interationalAddress":"Address"}},"communication":{"phone":"Phone","mobile":"Mobile","email":"Email"}}}})
import { Login } from './Login';
import { Person } from './Person';

export class Organization extends _BaseModel {
	
	static toString() {
		return 'Organization'
	}
	
	get __getters() {
		const self = this;
		return {
			get localAddress() {
        return (self.address.street ? self.address.street + ', ' : '') + (self.address.zipCode ? self.address.zipCode + '-' : '') + self.address.city;
    },
			get internationalAddress() {
        return (
            (self.address.street ? self.address.street + ', ' : '') +
            (self.address.zipCode ? self.address.zipCode + '-' : '') +
            (self.address.city ? self.address.city + ', ' : '') +
            self.address.country
        );
    },
			get name() {
        return self.general.fullName;
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Organization.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Organization', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Organization.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Organization', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Organization.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Organization', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Organization', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Organization', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Organization.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Organization', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Organization'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Organization) || _BaseModel.t('rules.reference', {modelName:'Organization', path:'meta.currentDocument'}) ],
				model: Organization,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Organization', path:'meta.revisions'}) ],
				model: Organization,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	contacts:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Person'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Organization', path:'references.contacts'}) ],
				model: Person,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	shortName:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.general.shortName'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'general.shortName'}) ],
},
    
	},
	
					
	fullName:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.general.fullName'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Organization', path:'general.fullName'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'general.fullName'}) ],
},
    
	},
	
					
	vatId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.general.vatId'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'general.vatId'}) ],
},
    
	},
	
},
			address: 				{
					
	street:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.address.street'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'address.street'}) ],
},
    
	},
	
					
	zipCode:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.address.zipCode'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'address.zipCode'}) ],
},
    
	},
	
					
	city:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.address.city'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'address.city'}) ],
},
    
	},
	
					
	country:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.address.country'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'address.country'}) ],
},
    
	},
	
},
			communication: 				{
					
	phone:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.communication.phone'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'communication.phone'}) ],
},
    
	},
	
					
	fax:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.communication.fax'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'communication.fax'}) ],
},
    
	},
	
					
	mobile:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.communication.mobile'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'communication.mobile'}) ],
},
    
	},
	
					
	email:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.communication.email'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'communication.email'}) ],
},
    
	},
	
					
	website:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization.communication.website'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Organization', path:'communication.website'}) ],
},
    
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Organization._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, address={}, communication={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.address=AddressClass.create(address);
		this.communication=CommunicationClass.create(communication);
		this._id=_id;
	}

	static create(data) {
		return new Organization(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Organization || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Organization.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Organization ? item : Organization.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({contacts=[], }={}){
		if(Array.isArray(contacts)){
			this.contacts=[];
			for(const item of contacts){
				if(typeof item === 'object')
					this.contacts.push(item instanceof Person ? item : Person.create(item))
				else this.contacts.push(item)
			}
		} else {
			this.contacts=contacts;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({shortName='', fullName='', vatId='', }={}){
		this.shortName=shortName;
		this.fullName=fullName;
		this.vatId=vatId;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class AddressClass {
	constructor({street='', zipCode='', city='', country='', }={}){
		this.street=street;
		this.zipCode=zipCode;
		this.city=city;
		this.country=country;
	}

	static create(data) {
		return new AddressClass(data);
	}
}

class CommunicationClass {
	constructor({phone='', fax='', mobile='', email='', website='', }={}){
		this.phone=phone;
		this.fax=fax;
		this.mobile=mobile;
		this.email=email;
		this.website=website;
	}

	static create(data) {
		return new CommunicationClass(data);
	}
}
